import React from 'react'
import type { EventGQL } from '../../../../Api'
import { getBroadcastImg, getGameTime, getShortDate } from '../../../../Utils'
import { TeamsCol } from './teamsCol'
import { Broadcaster, ListCon } from './styles'
import { Con } from '../../../../Components/Layout/Containers/ConStyles'
import { TableHeader } from '../../../../Components/Tables/TableHeader'
type TableParams = {
  events: EventGQL[]
}

export const ListView: React.FC<React.PropsWithChildren<TableParams>> = ({ events }) => {
  return (
    <ListCon>
      <table className="table">
        <thead>
          <tr>
            <TableHeader ariaLabel="Date">Date</TableHeader>
            <TableHeader ariaLabel="Location">Location</TableHeader>
            <TableHeader ariaLabel="Matchup">Matchup</TableHeader>
            <TableHeader ariaLabel="No Value"></TableHeader>
          </tr>
        </thead>
        <tbody>
          {events.length > 0 &&
            events.map((event) => (
              <tr key={event.slugname}>
                <td>
                  {`${getShortDate(event.startTime)} • ${getGameTime(
                    event.startTime
                  )} ET`}
                </td>
                <td>{event.location}</td>
                <td>
                  <TeamsCol
                    week={event.week}
                    description={event.description}
                    awayTeam={event.awayTeam?.fullName}
                    homeTeam={event.homeTeam?.fullName}
                    event={event}
                  />
                </td>
                <td>
                  {event.broadcaster.length > 0 && event.broadcaster[0] !== '' && (
                    <Con noMargin noPadding justify="center">
                      {getBroadcastImg(event.broadcaster).map((img, idx) => (
                        <Broadcaster key={idx} src={img} alt="broadcaster image" />
                      ))}
                    </Con>
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </ListCon>
  )
}
